import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {InputSwitch} from "primereact/inputswitch";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";
import {InputNumber} from "primereact/inputnumber";

const _FM_AdminvatgroupFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "admin-vat-group/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({})
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderVatgroupList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "admin-vat-group",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderVatgroupList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "admin-vat-group/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col p-col-align-center"}>
                  <h3 className={"p-m-0"}>{t('vatgroup_form')}</h3>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-5"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="vatgroup_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-5"}>
                  <Field name="persistent_name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"persistent_name"}/>
                      <label htmlFor="persistent_name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('persistent_name')}</label>
                      <span className="p-d-block">
                      <InputText id="persistent_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     persistent_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     persistent_name: e.target.value
                                   })
                                 }}
                                 value={formData.persistent_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-2"}>
                  <Field name="vat_percent" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"vat_percent"}/>
                      <label htmlFor="vat_percent"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('vat_percent')}</label>
                      <span className="p-d-block">
                      <InputText id="vat_percent" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     vat_percent: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     vat_percent: e.target.value
                                   })
                                 }}
                                 value={formData.vat_percent}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_AdminvatgroupFormComponent);
